import React, { useState } from 'react';
import styles from './LeadDatePicker.module.css';
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';

export default function LeadDatePicker(props: any) {
  const { setDate, date, setErrorDatePast, disablePortal = false } = props;

  const [newDate, setNewDate] = useState<any>();

  const onAccept = (date: any) => {
    if (date) {
      setDate(new Date(date).getTime());
      setNewDate(new Date(date).getTime());
      let currentDate = new Date();
      let selectedDate = new Date(date ?? 0);

      let isPast = selectedDate < currentDate;
      if (isPast) {
        setErrorDatePast(true);
      } else {
        setErrorDatePast(false);
      }
    }
  };

  return (
    <div>
      <label
        htmlFor="addTask"
        className={styles.leadDatePickerLabel}
        style={{
          minWidth: '30px',
          borderRadius: '50%',
          background: date !== undefined ? '#f5f5f7' : 'transparent',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDateTimePicker
            value={dayjs(newDate)}
            onChange={onAccept}
            sx={{
              input: { display: 'none' },
              fieldset: { display: 'none' },
              marginLeft: '-15px',
            }}
            onAccept={onAccept}
            disablePast
            closeOnSelect={false}
            slots={{
              openPickerIcon: CalendarTodayOutlinedIcon,
            }}
            autoFocus={false}
            disableOpenPicker={false}
            slotProps={{
              desktopPaper: {
                sx: {
                  width: 382,
                  height: 322,
                },
              },
              popper: {
                disablePortal: disablePortal,
                sx: {
                  zIndex: 200000,
                  '& .MuiPickersLayout-root': {
                    transform: 'scale(0.78)',
                    transformOrigin: 'top left',
                  },
                },
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      boundary: 'viewport',
                      altBoundary: true,
                      padding: 8,
                    },
                  },
                  {
                    name: 'flip',
                    options: {
                      fallbackPlacements: ['top', 'bottom'],
                    },
                  },
                ],
              },
            }}
          />
        </LocalizationProvider>
      </label>
    </div>
  );
}
